export default __webpack_public_path__ + "static/media/homeInsurance.1909ebb1.svg";